import { gql } from "@apollo/client";

const deleteCustomsShipmentPalletMutation = gql`
  mutation ($customsShipmentPalletId: ID!) {
    deleteCustomsShipmentPallet(
      customsShipmentPalletId: $customsShipmentPalletId
    ) {
      errors {
        customsShipmentPalletId
      }
      succeeded
    }
  }
`;

export default deleteCustomsShipmentPalletMutation;
